"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _en_US = _interopRequireDefault(require("../../action-sheet/locale/en_US"));

var _en_US2 = _interopRequireDefault(require("../../alert/locale/en_US"));

var _en_US3 = _interopRequireDefault(require("../../calendar/locale/en_US"));

var _en_US4 = _interopRequireDefault(require("../../confirm/locale/en_US"));

var _en_US5 = _interopRequireDefault(require("../../date-picker/locale/en_US"));

var _en_US6 = _interopRequireDefault(require("../../date-picker-view/locale/en_US"));

var _en_US7 = _interopRequireDefault(require("../../date-select/locale/en_US"));

var _en_US8 = _interopRequireDefault(require("../../picker/locale/en_US"));

var _en_US9 = _interopRequireDefault(require("../../stack-picker/locale/en_US"));

var _en_US10 = _interopRequireDefault(require("../../pull/locale/en_US"));

var _en_US11 = _interopRequireDefault(require("../../search-bar/locale/en_US"));

var _en_US12 = _interopRequireDefault(require("../../select/locale/en_US"));

var _en_US13 = _interopRequireDefault(require("../../keyboard/locale/en_US"));

var _en_US14 = _interopRequireDefault(require("../../image-preview/locale/en_US"));

var _default = {
  locale: 'en-US',
  ActionSheet: _en_US.default,
  Alert: _en_US2.default,
  Calendar: _en_US3.default,
  Confirm: _en_US4.default,
  DatePicker: _en_US5.default,
  DatePickerView: _en_US6.default,
  DateSelect: _en_US7.default,
  Picker: _en_US8.default,
  StackPicker: _en_US9.default,
  Pull: _en_US10.default,
  SearchBar: _en_US11.default,
  Select: _en_US12.default,
  Keyboard: _en_US13.default,
  ImagePreview: _en_US14.default
};
exports.default = _default;